import { render, staticRenderFns } from "./invoice_list.vue?vue&type=template&id=2b7e87f5&scoped=true"
import script from "./invoice_list.vue?vue&type=script&lang=js"
export * from "./invoice_list.vue?vue&type=script&lang=js"
import style0 from "./invoice_list.vue?vue&type=style&index=0&id=2b7e87f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7e87f5",
  null
  
)

export default component.exports